// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__LA3Ro","name":"Header_name__3VRkT","birthday":"Header_birthday__2mzR9","skeleton":"Header_skeleton__G-tpg"};